import * as React from 'react';
import { Link } from 'react-router-dom';
const classNames = require('classnames');

interface Props {
	id?: string;
	onClick?: (e?: any) => any;
	children?: {};
	aux?: boolean;
	to?: string;
	type?: string;
	disabled?: boolean;
	className?: string;
	tabIndex?: number;
}

const Button: React.StatelessComponent<Props> = ({
	to,
	onClick,
	className,
	type,
	disabled,
	children,
	tabIndex,
	...props
}) => {
	if (to) {
		return (
			<Link onClick={onClick} to={to} className={classNames('btn', className)} tabIndex={tabIndex} {...props}>
				{children}
			</Link>
		);
	} else {
		return (
			<button
				onClick={onClick}
				className={classNames('btn', className)}
				type={type}
				disabled={disabled}
				tabIndex={tabIndex}
				{...props}
			>
				{children}
			</button>
		);
	}
};

export default Button;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/buttons/Button.tsx